import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const CELLS = [
  { value: 7, unit: "+", label: "numbers.n1", cap: "numbers.n1c" },
  { value: 217, unit: "+", label: "numbers.n2", cap: "numbers.n2c" },
  { value: 24, unit: "h", label: "numbers.n3", cap: "numbers.n3c" },
  { value: 4.9, unit: "★", label: "numbers.n4", cap: "numbers.n4c" },
];

export default function NumbersBand() {
  const { t } = useTranslation();
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const figs = Array.from(root.querySelectorAll<HTMLElement>("[data-count]"));
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target as HTMLElement;
      const target = parseFloat(el.dataset.count || "0");
      const decimals = el.dataset.count?.includes(".") ? 1 : 0;
      const start = performance.now();
      const step = (now: number) => {
        const p = Math.min(1, (now - start) / 1200);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      io.unobserve(el);
    }), { rootMargin: "0px 0px -20% 0px" });
    figs.forEach((f) => io.observe(f));
    return () => io.disconnect();
  }, []);

  return (
    <section className="band" ref={ref} aria-label={t("numbers.title")}>
      <div className="band-grid">
        {CELLS.map((c) => (
          <div key={c.label} data-reveal>
            <div className="band-figure">
              <span data-count={c.value}>{c.value}</span>
              <span className="unit">{c.unit}</span>
            </div>
            <p className="mono text-[10.5px] tracking-[.14em] uppercase mt-3" style={{ color: "var(--accent)" }}>
              {t(c.label)}
            </p>
            <p className="band-cap">{t(c.cap)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}